'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  disabled: _propTypes2.default.bool
};

var defaultProps = {
  disabled: false
};

/** PROP RECEIVERS */
var stateProp = function stateProp(_ref) {
  var disabled = _ref.disabled;
  return disabled && 'cursor: default;';
};

var base = function base(_ref2) {
  var themeFromProvider = _ref2.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);

  var fontFamily = theme.reactackle.fontFamily[theme.reactackle.body.fontFamily];

  return '\n    &,\n    & *,\n    *::after,\n    *::before {\n      font-family: ' + fontFamily + ';\n      box-sizing: border-box;\n    }\n  ';
};

/** STYLES */
var ToggleStyled = exports.ToggleStyled = _styledComponents2.default.div.withConfig({
  displayName: 'ToggleStyled'
})(['', ';', ';'], base, stateProp);

ToggleStyled.propTypes = propTypes;
ToggleStyled.defaultProps = defaultProps;
ToggleStyled.displayName = 'ToggleStyled';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-toggle-button/dist/styles/ToggleStyled.js
// module id = 871
// module chunks = 0